import { createContext } from 'react'

export const ErrorScrollContext = createContext()

export function scrollTo(view) {
    if (view)
        view.current.scrollIntoView({ behavior: 'smooth' });
}